module.exports = __webpack_public_path__ + "img/volume_disabled.11193bc4.svg";